import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function Master() {
  const [logado, setLogado] = useState(!!localStorage.getItem('master_token'));
  const [form, setForm] = useState({ email: '', senha: '' });
  const [empresas, setEmpresas] = useState([]);
  const [dashboard, setDashboard] = useState(null);
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const [salvando, setSalvando] = useState(null); // id da empresa em ação Asaas
  const [editado, setEditado] = useState({}); // { [id]: { desconto_percentual, isencao_ate, trial_ate } }
  const [filtro, setFiltro] = useState('ativas'); // aba default: é o que se olha na maior parte do tempo
  const [busca, setBusca] = useState('');
  const [cadAsaas, setCadAsaas] = useState(null); // formulário do modal "Cadastrar no Asaas" (null = fechado)
  const [cadErro, setCadErro] = useState('');
  const [cadEnviando, setCadEnviando] = useState(false);

  const fmt = v => 'R$ ' + parseFloat(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
  const token = () => localStorage.getItem('master_token');
  const auth = () => ({ headers: { Authorization: 'Bearer ' + token() } });
  const dateInput = v => v ? new Date(v).toISOString().split('T')[0] : '';

  const login = async (e) => {
    e.preventDefault();
    setErro('');
    try {
      const r = await api.post('/master/login', form);
      localStorage.setItem('master_token', r.data.token);
      setLogado(true);
    } catch(err) { setErro(err.response?.data?.error || 'Erro'); }
  };

  const carregar = async () => {
    setLoading(true);
    try {
      const [emp, dash] = await Promise.all([
        api.get('/master/empresas', auth()),
        api.get('/master/dashboard', auth()),
      ]);
      setEmpresas(emp.data);
      setDashboard(dash.data);
      setEditado({});
    } catch(e) { setErro('Erro ao carregar'); }
    finally { setLoading(false); }
  };

  // Valor de um campo editável (usa o rascunho local, senão o valor da empresa)
  const campo = (emp, key) => {
    const draft = editado[emp.id];
    if (draft && key in draft) return draft[key];
    if (key === 'desconto_percentual') return emp.desconto_percentual ?? 0;
    return dateInput(emp[key]);
  };
  const setCampo = (id, key, val) => setEditado(p => ({ ...p, [id]: { ...p[id], [key]: val } }));

  const toggleAtivo = async (emp) => {
    await api.put('/master/empresas/' + emp.id, { ativo: !emp.ativo }, auth());
    carregar();
  };

  const mudarPlano = async (emp, plano) => {
    await api.put('/master/empresas/' + emp.id, { plano }, auth());
    carregar();
  };

  const salvarCobranca = async (emp) => {
    setSalvando(emp.id);
    try {
      await api.put('/master/empresas/' + emp.id, {
        desconto_percentual: parseFloat(campo(emp, 'desconto_percentual')) || 0,
        isencao_ate: campo(emp, 'isencao_ate') || '',
        trial_ate: campo(emp, 'trial_ate') || '',
      }, auth());
      await carregar();
    } catch(e) { alert(e.response?.data?.error || 'Erro ao salvar'); }
    finally { setSalvando(null); }
  };

  // Entra na conta do tenant (suporte). O master_token continua no localStorage:
  // é a sessão original do master, restaurada ao clicar "Voltar ao Master".
  const impersonar = async (emp) => {
    if (!window.confirm(`Entrar no sistema como "${emp.nome}"? Você verá os dados reais desse cliente.`)) return;
    setSalvando(emp.id);
    try {
      const r = await api.post('/master/impersonate', { empresa_id: emp.id }, auth());
      localStorage.setItem('token', r.data.token);
      localStorage.setItem('usuario', JSON.stringify(r.data.usuario));
      localStorage.setItem('impersonacao', JSON.stringify({ empresa_id: emp.id, empresa_nome: r.data.empresa_nome }));
      window.location.href = '/dashboard';
    } catch(e) {
      alert(e.response?.data?.error || 'Erro ao entrar como empresa');
      setSalvando(null);
    }
  };

  const aplicarAsaas = async (emp) => {
    if (!window.confirm(`Aplicar o valor com desconto/isenção na assinatura Asaas de "${emp.nome}"? As cobranças pendentes serão atualizadas.`)) return;
    setSalvando(emp.id);
    try {
      // Garante que o desconto/isenção atual está salvo antes de enviar ao Asaas
      await api.put('/master/empresas/' + emp.id, {
        desconto_percentual: parseFloat(campo(emp, 'desconto_percentual')) || 0,
        isencao_ate: campo(emp, 'isencao_ate') || '',
        trial_ate: campo(emp, 'trial_ate') || '',
      }, auth());
      const r = await api.post('/master/empresas/' + emp.id + '/aplicar-desconto', {}, auth());
      alert(`Assinatura atualizada no Asaas. Novo valor: ${fmt(r.data.valor_aplicado)}`);
      await carregar();
    } catch(e) { alert(e.response?.data?.error || 'Erro ao aplicar no Asaas'); }
    finally { setSalvando(null); }
  };

  // Modal "Cadastrar no Asaas": valor = cobrança com desconto (ou o do plano, se isento);
  // 1º vencimento = dia seguinte ao fim do trial/isenção, senão daqui a 30 dias (igual ao cadastro).
  const abrirCadastroAsaas = (emp) => {
    const hojeStr = new Date().toISOString().split('T')[0];
    const fim = [dateInput(emp.trial_ate), dateInput(emp.isencao_ate)].filter(d => d && d >= hojeStr).sort().pop();
    const venc = fim ? new Date(fim + 'T12:00:00') : new Date();
    venc.setDate(venc.getDate() + (fim ? 1 : 30));
    setCadErro('');
    setCadAsaas({
      empresa_id: emp.id, empresa_nome: emp.nome,
      nome: emp.nome || '', email: emp.email || '', telefone: emp.telefone || '', cpf_cnpj: emp.cnpj || '',
      valor: emp.valor_efetivo > 0 ? emp.valor_efetivo : emp.valor_base,
      billing_type: 'UNDEFINED', vencimento: venc.toISOString().split('T')[0],
      notificar_email: true, notificar_whatsapp: true,
    });
  };

  const enviarCadastroAsaas = async (ev) => {
    ev.preventDefault();
    if (!window.confirm(`Criar cliente e assinatura mensal de ${fmt(cadAsaas.valor)} no Asaas para "${cadAsaas.empresa_nome}"? Isso gera cobranças reais.`)) return;
    setCadErro('');
    setCadEnviando(true);
    try {
      const r = await api.post('/master/asaas/cadastrar', cadAsaas, auth());
      setCadAsaas(null);
      alert('Empresa cadastrada no Asaas.' + (r.data.aviso ? '\n\nAtenção: ' + r.data.aviso : ''));
      await carregar();
    } catch(e) { setCadErro(e.response?.data?.error || 'Erro ao cadastrar no Asaas'); }
    finally { setCadEnviando(false); }
  };

  useEffect(() => { if (logado) carregar(); }, [logado]);

  if (!logado) return (
    <div style={{ minHeight: '100vh', background: '#0F1E35', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: '16px', padding: '40px', width: '380px' }}>
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ fontSize: '24px', fontWeight: '800', color: '#1A3A5C' }}>AutoMais</div>
          <div style={{ fontSize: '13px', color: '#6B7A8D' }}>Painel Master</div>
        </div>
        <form onSubmit={login}>
          <div style={{ marginBottom: '12px' }}>
            <input type='email' placeholder='Email master' value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
              style={{ width: '100%', padding: '10px 12px', background: '#F4F6F9', border: '1px solid rgba(26,58,92,0.15)', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <input type='password' placeholder='Senha' value={form.senha} onChange={e => setForm(f => ({ ...f, senha: e.target.value }))}
              style={{ width: '100%', padding: '10px 12px', background: '#F4F6F9', border: '1px solid rgba(26,58,92,0.15)', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
          </div>
          {erro && <div style={{ color: '#C0392B', fontSize: '13px', marginBottom: '12px' }}>{erro}</div>}
          <button type='submit' style={{ width: '100%', padding: '12px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', fontWeight: '700', cursor: 'pointer', fontSize: '14px' }}>Entrar</button>
        </form>
      </div>
    </div>
  );

  const card = (label, valor, cor) => (
    <div style={{ background: '#fff', borderRadius: '12px', padding: '16px 22px', textAlign: 'center', flex: 1, minWidth: '140px' }}>
      <div style={{ fontSize: '11px', color: '#9AA3AE', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</div>
      <div style={{ fontSize: '24px', fontWeight: '800', color: cor }}>{valor}</div>
    </div>
  );

  const hoje = new Date().toISOString().split('T')[0];
  const emTrial = e => e.trial_ate && dateInput(e.trial_ate) >= hoje;
  const emIsencao = e => e.isencao_ate && dateInput(e.isencao_ate) >= hoje;

  // --- Filtros / ordenação da lista (não altera cobrança, Asaas nem impersonação) ---
  // "Em Trial" é um recorte das ativas (empresa em trial continua ativa), igual aos
  // cards de resumo do topo — por isso ativas(4) + inativas(7) = total(11), com o
  // trial aparecendo também dentro de "Ativas".
  const PREDICADO = {
    todas:    () => true,
    ativas:   e => !!e.ativo,
    trial:    e => !!emTrial(e),
    inativas: e => !e.ativo,
    // Também é recorte: inadimplente dentro da carência segue em "Ativas"; suspensa vai p/ "Inativas".
    // Sai daqui sozinha quando o Asaas confirma o pagamento (webhook/job zeram inadimplente).
    inadimplentes: e => !!e.inadimplente,
  };
  const ABAS = [
    { key: 'todas',    label: 'Todas' },
    { key: 'ativas',   label: 'Ativas' },
    { key: 'inativas', label: 'Inativas' },
    { key: 'trial',    label: 'Em Trial' },
    { key: 'inadimplentes', label: 'Inadimplentes' },
  ];
  const dataBR = d => d ? String(d).split('T')[0].split('-').reverse().join('/') : ''; // coluna date, sem fuso
  // Contadores saem do mesmo predicado do filtro: número da aba e lista nunca divergem.
  const contar = key => empresas.filter(PREDICADO[key]).length;

  // Ordem dos grupos: ativas -> trial -> inativas; dentro do grupo, por nome.
  const grupoOrdem = e => (!e.ativo ? 2 : (emTrial(e) ? 1 : 0));
  const normalizar = t => (t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  const termo = normalizar(busca.trim());
  const empresasVisiveis = empresas
    .filter(PREDICADO[filtro] || PREDICADO.todas)
    .filter(e => !termo || normalizar(e.nome).includes(termo))
    .sort((a, b) => (grupoOrdem(a) - grupoOrdem(b)) || (a.nome || '').localeCompare(b.nome || '', 'pt-BR'));

  // Link do cliente no painel Asaas
  const asaasClienteUrl = id => 'https://www.asaas.com/customerAccount/show/' + id;
  const campoModal = { display: 'block', marginTop: '4px', width: '100%', padding: '8px 10px', border: '1px solid rgba(26,58,92,0.2)', borderRadius: '7px', fontSize: '13px', boxSizing: 'border-box' };
  const labelModal = { display: 'block', fontSize: '11px', color: '#6B7A8D', fontWeight: '600', marginBottom: '12px' };
  const setCad = (k, v) => setCadAsaas(f => ({ ...f, [k]: v }));

  // Cor da borda e opacidade por status
  const corBorda = e => (!e.ativo ? '#9AA3AE' : (emTrial(e) ? '#1E5FA5' : '#2D7D4F'));

  return (
    <div style={{ minHeight: '100vh', background: '#F4F6F9', padding: '24px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div>
            <div style={{ fontSize: '22px', fontWeight: '800', color: '#1A3A5C' }}>AutoMais — Painel Master</div>
            <div style={{ fontSize: '13px', color: '#6B7A8D' }}>{empresas.length} empresas cadastradas</div>
          </div>
          <button onClick={() => { localStorage.removeItem('master_token'); setLogado(false); }}
            style={{ padding: '10px 16px', background: '#FDECEA', border: 'none', color: '#C0392B', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>Sair</button>
        </div>

        {/* Dashboard */}
        <div style={{ display: 'flex', gap: '14px', marginBottom: '24px', flexWrap: 'wrap' }}>
          {card('Empresas Ativas', dashboard?.empresas_ativas ?? '—', '#2D7D4F')}
          {card('MRR', dashboard ? fmt(dashboard.mrr) : '—', '#1A3A5C')}
          {card('Inadimplentes', dashboard?.empresas_inadimplentes ?? '—', '#C0392B')}
          {card('Em Trial', dashboard?.empresas_trial ?? '—', '#E67E22')}
        </div>

        {/* Filtros + busca */}
        <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
            {ABAS.map(aba => {
              const ativa = filtro === aba.key;
              return (
                <button key={aba.key} onClick={() => setFiltro(aba.key)}
                  style={{ padding: '8px 14px', background: ativa ? '#1A3A5C' : '#fff', border: '1px solid ' + (ativa ? '#1A3A5C' : 'rgba(26,58,92,0.15)'), color: ativa ? '#fff' : '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontSize: '12.5px', fontWeight: '700' }}>
                  {aba.label} ({contar(aba.key)})
                </button>
              );
            })}
          </div>
          <input type='search' placeholder='Buscar empresa...' value={busca} onChange={ev => setBusca(ev.target.value)}
            style={{ marginLeft: 'auto', padding: '8px 12px', minWidth: '200px', background: '#fff', border: '1px solid rgba(26,58,92,0.15)', borderRadius: '8px', fontSize: '13px', outline: 'none' }} />
        </div>

        {loading ? <div style={{ textAlign: 'center', color: '#9AA3AE' }}>Carregando...</div> : empresasVisiveis.length === 0 ? (
          <div style={{ background: '#fff', borderRadius: '12px', padding: '32px', textAlign: 'center', color: '#9AA3AE', fontSize: '13px' }}>
            {busca ? `Nenhuma empresa encontrada para "${busca}".` : 'Nenhuma empresa neste filtro.'}
          </div>
        ) : (
          <div style={{ display: 'grid', gap: '12px' }}>
            {empresasVisiveis.map(e => (
              <div key={e.id} style={{ background: '#fff', borderRadius: '12px', padding: '20px 24px', borderLeft: `4px solid ${corBorda(e)}`, opacity: e.ativo ? 1 : 0.6 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px', flexWrap: 'wrap' }}>
                      <div style={{ fontSize: '15px', fontWeight: '700', color: '#1C2533' }}>{e.nome}</div>
                      <span style={{ background: e.plano === 'completo' ? '#E6F1FB' : '#F4F6F9', color: e.plano === 'completo' ? '#1A3A5C' : '#6B7A8D', padding: '2px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: '700' }}>
                        {e.plano === 'completo' ? 'Completo R$250' : 'Básico R$150'}
                      </span>
                      <span style={{ background: e.ativo ? '#EAF5EE' : '#FDECEA', color: e.ativo ? '#2D7D4F' : '#C0392B', padding: '2px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: '700' }}>
                        {e.ativo ? 'Ativa' : (e.suspensa_inadimplencia ? 'Suspensa' : 'Inativa')}
                      </span>
                      {e.inadimplente && <span style={{ background: '#FDECEA', color: '#C0392B', padding: '2px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: '700' }}>Inadimplente{e.inadimplente_desde ? ` desde ${dataBR(e.inadimplente_desde)}` : ''}</span>}
                      {emTrial(e) && <span style={{ background: '#FDF1E6', color: '#E67E22', padding: '2px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: '700' }}>Trial até {new Date(e.trial_ate).toLocaleDateString('pt-BR')}</span>}
                      {emIsencao(e) && <span style={{ background: '#EFEAF5', color: '#8E44AD', padding: '2px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: '700' }}>Isento até {new Date(e.isencao_ate).toLocaleDateString('pt-BR')}</span>}
                    </div>
                    <div style={{ fontSize: '12px', color: '#9AA3AE', display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                      {e.cidade && <span>📍 {e.cidade}/{e.estado}</span>}
                      {e.telefone && <span>📱 {e.telefone}</span>}
                      {e.email_exibicao && <span>✉️ {e.email_exibicao}</span>}
                      {e.cnpj && <span>🪪 CPF/CNPJ: {e.cnpj}</span>}
                      <span>👥 {e.total_usuarios} usuários</span>
                      <span>🏍️ {e.total_veiculos} veículos</span>
                      <span>💰 {e.total_vendas} vendas</span>
                      <span>🧾 Cobrança: {fmt(e.valor_efetivo)}</span>
                      {e.proximo_vencimento && <span>⏰ Vence {dataBR(e.proximo_vencimento)}</span>}
                      <span>📅 {new Date(e.created_at).toLocaleDateString('pt-BR')}</span>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <select value={e.plano} onChange={ev => mudarPlano(e, ev.target.value)}
                      style={{ padding: '6px 10px', border: '1px solid rgba(26,58,92,0.2)', borderRadius: '7px', fontSize: '12px', cursor: 'pointer', background: '#fff' }}>
                      <option value='basico'>Básico</option>
                      <option value='completo'>Completo</option>
                    </select>
                    <button onClick={() => toggleAtivo(e)}
                      style={{ padding: '6px 14px', background: e.ativo ? '#FDECEA' : '#EAF5EE', border: 'none', color: e.ativo ? '#C0392B' : '#2D7D4F', borderRadius: '7px', cursor: 'pointer', fontSize: '12px', fontWeight: '700' }}>
                      {e.ativo ? 'Desativar' : 'Ativar'}
                    </button>
                    <button onClick={() => impersonar(e)} disabled={salvando === e.id}
                      style={{ padding: '6px 14px', background: '#F59E0B', border: 'none', color: '#3B2600', borderRadius: '7px', cursor: salvando === e.id ? 'default' : 'pointer', fontSize: '12px', fontWeight: '700', opacity: salvando === e.id ? 0.6 : 1 }}>
                      Entrar como
                    </button>
                  </div>
                </div>

                {/* Controles de cobrança */}
                <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #EEF1F5', display: 'flex', gap: '16px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                  <label style={{ fontSize: '11px', color: '#6B7A8D', fontWeight: '600' }}>
                    Desconto (%)
                    <input type='number' min='0' max='100' step='1' value={campo(e, 'desconto_percentual')}
                      onChange={ev => setCampo(e.id, 'desconto_percentual', ev.target.value)}
                      style={{ display: 'block', marginTop: '4px', width: '90px', padding: '7px 9px', border: '1px solid rgba(26,58,92,0.2)', borderRadius: '7px', fontSize: '13px' }} />
                  </label>
                  <label style={{ fontSize: '11px', color: '#6B7A8D', fontWeight: '600' }}>
                    Isenção até
                    <input type='date' value={campo(e, 'isencao_ate')}
                      onChange={ev => setCampo(e.id, 'isencao_ate', ev.target.value)}
                      style={{ display: 'block', marginTop: '4px', padding: '7px 9px', border: '1px solid rgba(26,58,92,0.2)', borderRadius: '7px', fontSize: '13px' }} />
                  </label>
                  <label style={{ fontSize: '11px', color: '#6B7A8D', fontWeight: '600' }}>
                    Trial até
                    <input type='date' value={campo(e, 'trial_ate')}
                      onChange={ev => setCampo(e.id, 'trial_ate', ev.target.value)}
                      style={{ display: 'block', marginTop: '4px', padding: '7px 9px', border: '1px solid rgba(26,58,92,0.2)', borderRadius: '7px', fontSize: '13px' }} />
                  </label>
                  <button onClick={() => salvarCobranca(e)} disabled={salvando === e.id}
                    style={{ padding: '8px 16px', background: '#E6F1FB', border: 'none', color: '#1A3A5C', borderRadius: '7px', cursor: 'pointer', fontSize: '12px', fontWeight: '700', opacity: salvando === e.id ? 0.6 : 1 }}>
                    Salvar
                  </button>
                  <button onClick={() => aplicarAsaas(e)} disabled={salvando === e.id || !e.asaas_subscription_id}
                    title={e.asaas_subscription_id ? 'Atualiza o valor da assinatura no Asaas' : 'Empresa sem assinatura Asaas'}
                    style={{ padding: '8px 16px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '7px', cursor: e.asaas_subscription_id ? 'pointer' : 'not-allowed', fontSize: '12px', fontWeight: '700', opacity: (salvando === e.id || !e.asaas_subscription_id) ? 0.5 : 1 }}>
                    {salvando === e.id ? 'Aplicando...' : 'Aplicar desconto no Asaas'}
                  </button>
                  {e.asaas_customer_id ? (
                    <a href={asaasClienteUrl(e.asaas_customer_id)} target='_blank' rel='noopener noreferrer'
                      title='Abrir cliente no painel Asaas'
                      style={{ alignSelf: 'center', fontSize: '12px', fontWeight: '700', color: '#1E5FA5' }}>
                      Asaas: {e.asaas_customer_id} ↗
                    </a>
                  ) : (
                    <button onClick={() => abrirCadastroAsaas(e)} disabled={salvando === e.id}
                      style={{ padding: '8px 16px', background: '#2D7D4F', border: 'none', color: '#fff', borderRadius: '7px', cursor: 'pointer', fontSize: '12px', fontWeight: '700', opacity: salvando === e.id ? 0.6 : 1 }}>
                      Cadastrar no Asaas
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modal: Cadastrar no Asaas */}
      {cadAsaas && (
        <div onClick={() => !cadEnviando && setCadAsaas(null)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(15,30,53,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' }}>
          <form onSubmit={enviarCadastroAsaas} onClick={ev => ev.stopPropagation()}
            style={{ background: '#fff', borderRadius: '14px', padding: '24px 28px', width: '440px', maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ fontSize: '17px', fontWeight: '800', color: '#1A3A5C', marginBottom: '2px' }}>Cadastrar no Asaas</div>
            <div style={{ fontSize: '12px', color: '#9AA3AE', marginBottom: '18px' }}>{cadAsaas.empresa_nome} — cria o cliente e a assinatura mensal</div>

            <label style={labelModal}>Nome do cliente
              <input required value={cadAsaas.nome} onChange={ev => setCad('nome', ev.target.value)} style={campoModal} /></label>
            <label style={labelModal}>CPF/CNPJ (obrigatório no Asaas)
              <input required value={cadAsaas.cpf_cnpj} onChange={ev => setCad('cpf_cnpj', ev.target.value)} style={campoModal} /></label>
            <label style={labelModal}>E-mail
              <input type='email' value={cadAsaas.email} onChange={ev => setCad('email', ev.target.value)} style={campoModal} /></label>
            <label style={labelModal}>Telefone/WhatsApp
              <input value={cadAsaas.telefone} onChange={ev => setCad('telefone', ev.target.value)} style={campoModal} /></label>
            <div style={{ display: 'flex', gap: '12px' }}>
              <label style={{ ...labelModal, flex: 1 }}>Valor mensal (R$)
                <input type='number' required min='0.01' step='0.01' value={cadAsaas.valor} onChange={ev => setCad('valor', ev.target.value)} style={campoModal} /></label>
              <label style={{ ...labelModal, flex: 1 }}>1º vencimento
                <input type='date' required value={cadAsaas.vencimento} onChange={ev => setCad('vencimento', ev.target.value)} style={campoModal} /></label>
            </div>
            {/^\d{4}-\d{2}-\d{2}$/.test(cadAsaas.vencimento) && (
              <div style={{ fontSize: '12px', color: '#1E5FA5', margin: '-6px 0 12px' }}>
                As cobranças seguintes serão geradas todo dia {parseInt(cadAsaas.vencimento.slice(8, 10))} de cada mês
              </div>
            )}
            <label style={labelModal}>Forma de pagamento
              <select value={cadAsaas.billing_type} onChange={ev => setCad('billing_type', ev.target.value)} style={campoModal}>
                <option value='UNDEFINED'>Boleto ou Pix (cliente escolhe)</option>
                <option value='BOLETO'>Boleto</option>
                <option value='PIX'>Pix</option>
              </select></label>
            <div style={{ fontSize: '11px', color: '#6B7A8D', fontWeight: '600', marginBottom: '6px' }}>Notificar cobranças por</div>
            <div style={{ display: 'flex', gap: '18px', marginBottom: '18px', fontSize: '13px', color: '#1C2533' }}>
              <label><input type='checkbox' checked={cadAsaas.notificar_whatsapp} onChange={ev => setCad('notificar_whatsapp', ev.target.checked)} /> WhatsApp/SMS</label>
              <label><input type='checkbox' checked={cadAsaas.notificar_email} onChange={ev => setCad('notificar_email', ev.target.checked)} /> E-mail</label>
            </div>

            {cadErro && <div style={{ color: '#C0392B', fontSize: '13px', marginBottom: '12px' }}>{cadErro}</div>}
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button type='button' onClick={() => setCadAsaas(null)} disabled={cadEnviando}
                style={{ padding: '10px 16px', background: '#F4F6F9', border: 'none', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>Cancelar</button>
              <button type='submit' disabled={cadEnviando}
                style={{ padding: '10px 16px', background: '#2D7D4F', border: 'none', color: '#fff', borderRadius: '8px', cursor: cadEnviando ? 'default' : 'pointer', fontWeight: '700', fontSize: '13px', opacity: cadEnviando ? 0.6 : 1 }}>
                {cadEnviando ? 'Criando...' : 'Criar e ativar cobrança'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
